import React,{Component} from 'react';
import { BrowserRouter as Router, Link  } from 'react-router-dom';

class Units extends Component{
    
          
    render() {

        return (
            <tr>
                <td className="text-center">{this.props.details.unit}</td>
                <td className="text-center">
                    <div className="btn-group btn-group-xs">
                        <Link to={`unit/${this.props.index}/edit`} data-toggle="tooltip" className="btn btn-default"> <i className="fa fa-pencil"></i></Link>
                        <button className="btn btn-xs btn-danger" type="submit" onClick={()=>this.props.removeUnit(this.props.index)}><i className="fa fa-times"></i></button> 
                    </div>
                </td>
            </tr>
        );
    }
}

export default  Units;



// WEBPACK FOOTER //
// ./src/components/Units.js